<template>
  <table class="table table-bordered table-hover">
    <thead class="bg-light">
      <tr>
        <th>Email Address</th>
        <th>Account Type</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="user in users" :key="user.uid">
        <td>{{ user.email }}</td>
        <td>
          <span v-if="user.isSpeaker" class="badge badge-primary mr-1"
            >Speaker</span
          >
          <span v-if="user.accountType === 'Admin'" class="badge badge-success"
            >Admin</span
          >
          <span
            v-else-if="user.accountType === 'Viewer'"
            class="badge badge-info"
            >Viewer</span
          >
          <span v-else class="badge badge-warning">Disabled</span>
        </td>
        <td>
          <button
            v-if="user.accountType === 'Disabled'"
            class="btn btn-link"
            @click="() => promoteUser(user)"
          >
            Promote
          </button>
          <button
            v-if="user.accountType === 'Viewer'"
            class="btn btn-link"
            @click="() => demoteUser(user)"
          >
            Demote
          </button>
          <button
            v-if="user.accountType !== 'Admin'"
            class="btn btn-link text-danger"
            @click="() => deleteUser(user)"
          >
            Delete
          </button>
          <button v-if="user.accountType !== 'Admin'" class="btn btn-link">
            Send Password Reset Email
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    users: {
      type: Array,
      required: true,
      default: () => {
        return [];
      }
    },
    promoteUser: {
      type: Function,
      required: true,
      default: () => {}
    },
    demoteUser: {
      type: Function,
      required: true,
      default: () => {}
    },
    deleteUser: {
      type: Function,
      required: true,
      default: () => {}
    }
  }
};
</script>

<style></style>
